import Vue from "vue";
import VueMediaQ from "vue-media-q";

Vue.use(VueMediaQ, {
  xs: -1,
  sm: 600,
  md: 600,
  lg: Infinity,
});
